import Base from '../base';

const ACTIVE_STATE_CLASS = 'is-active';

class ProductTable extends Base {
	start() {
		this.on('click');
		this.eventbus.on('chart:plotline:toggled', options => this.onPlotlineToggled(options));
	}

	onClick(e) {
		const { target } = e;

		if (target.classList.contains('js-plotline-toggle')) {
			this.togglePlotline(target);
		}
	}


	togglePlotline(target) {
		this.eventbus.emit('chart:plotline:toggle', target.dataset);
	}

	onPlotlineToggled({ id, action }) {
		const button = this.el.querySelector(`[data-isin=${id}`);

		if (action === 'added') {
			button.classList.add(ACTIVE_STATE_CLASS);
		} else {
			button.classList.remove(ACTIVE_STATE_CLASS);
		}
	}
}

export default ProductTable;
